import { api } from '../api';

/**
 * Reenvia o convite de primeiro acesso (tarefa 0.9 do roadmap B2G).
 *
 * Existe porque a conta passou a **nascer sem senha**: antes, o back gerava uma
 * senha aleatória (que ninguém usava e que ainda voltava em claro na resposta de
 * `POST /users`). Com o convite sendo o único caminho de primeiro acesso, quem
 * perde a janela de 48 h ficaria com uma conta inalcançável — "esqueci minha senha"
 * é fluxo de quem **tem** senha.
 *
 * Escopo `register_user`. Responde 400 se o usuário já definiu a senha dele.
 */
export const resendInvite = async (userId: string): Promise<void> => {
  await api.post(`/users/${userId}/invite`);
};
